export const fontSizes = [8, 9, 10, 11, 12, 14, 16, 20, 24, 28, 32, 48, 72]
export const fontFamilies = ['Arial', 'Times', 'Verdana', 'Georgia', 'Palatino']
export const spacing = [
  0,
  1,
  2,
  3,
  4,
  5,
  10,
  15,
  20,
  25,
  30,
  35,
  40,
  45,
  50,
  60,
  70,
  80,
  90,
  100
]

export const backgroundRepeat = [
  'repeat',
  'repeat-x',
  'repeat-y',
  'no-repeat',
  'space',
  'round'
]

export const backgroundSize = [
  'auto',
  'cover',
  'contain',
  '10%',
  '20%',
  '40%',
  '50%',
  '60%',
  '70%',
  '80%',
  '90%',
  '100%'
]

export const borderWidth = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  15,
  20,
  25,
  30,
  35,
  40,
  45,
  50
]

export const borderStyle = ['none', 'dotted', 'dashed', 'solid', 'double']

export const textAlign = ['center', 'left', 'right', 'justify']

export const size = [
  'auto',
  '10%',
  '20%',
  '30%',
  '40%',
  '50%',
  '60%',
  '70%',
  '80%',
  '90%',
  '100%'
]

export const flexRatio = ['0 auto', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
